const CATEGORY_LABEL_OVERRIDES = { SIGN_IN: "Log in" };

export const formatCategoryName = (category) => {
  if (!category) return "";
  if (CATEGORY_LABEL_OVERRIDES[category]) return CATEGORY_LABEL_OVERRIDES[category];

  return category
    .split(/[_ ]+/)
    .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

// Normalises a form's categories, falling back to the deprecated single `category`.
export const getFormCategories = (form) => {
  if (Array.isArray(form?.categories) && form.categories.length > 0) {
    return form.categories;
  }
  return form?.category ? [form.category] : [];
};

// Mirrors Form.FormCategories on the backend (value + label), in display order.
export const FORM_CATEGORY_OPTIONS = [
  "SIGN_UP",
  "SIGN_IN",
  "APPOINTMENT_BOOKING",
  "LEAD_GENERATION",
  "SHOPPING",
  "CONTACT_US",
  "CUSTOMER_SUPPORT",
  "SURVEY",
  "OTHER",
].map((value) => ({ value, label: formatCategoryName(value) }));

export const FORM_NAME_MIN_LENGTH = 3;
export const FORM_NAME_MAX_LENGTH = 200;

// Every Flow JSON element, including those inside If branches ("Show only when"
// questions) and Switch cases.
export const flattenElements = (elements) =>
  (elements || []).flatMap((el) =>
    el?.type === "If"
      ? flattenElements([...(el.then || []), ...(el.else || [])])
      : el?.type === "Switch"
        ? flattenElements(Object.values(el.cases || {}).flat())
        : [el],
  );

// Client-side name rules; returns an error message or "".
export const getFormNameError = (name) => {
  const trimmed = (name || "").trim();
  if (!trimmed) return "Enter a form name";
  if (trimmed.length < FORM_NAME_MIN_LENGTH) {
    return `Name must be at least ${FORM_NAME_MIN_LENGTH} characters`;
  }
  if (trimmed.length > FORM_NAME_MAX_LENGTH) {
    return `Name must be at most ${FORM_NAME_MAX_LENGTH} characters`;
  }
  return "";
};
